<sl-title title="Banking Info"></sl-title>
<mat-card class="linq-card--legacy">
	<sl-filters [filters]="filters" searchOnly="true" (filtersUpdated)="applyFilter($event)">
		<span class="spacer"></span>
		<sl-title-buttons [buttons]="titleButtons"></sl-title-buttons>
	</sl-filters>
	<sl-table [config]="config" [data]="data" [filters]="filters"></sl-table>
</mat-card>

<ng-template #defaultCheckMark let-row="row">
	<mat-icon *ngIf="row?.Id === defaultBankId" color="primary">check</mat-icon>
</ng-template>